const LOCAL_CONTENT_PREFIX = 'platewell.import-local:';

export function stashLocalImportContents(importId: string, files: File[], fileIds: string[]): void {
  void Promise.all(
    files.map(async (file, index) => {
      const id = fileIds[index];
      if (id == null) return null;
      const name = file.name.toLowerCase();
      if (!name.endsWith('.json') && !name.endsWith('.jsonld')) return null;
      return { id, content: await file.text() };
    }),
  ).then((entries) => {
    const payload: Record<string, string> = {};
    for (const entry of entries) {
      if (entry != null) payload[entry.id] = entry.content;
    }
    if (Object.keys(payload).length === 0) return;
    sessionStorage.setItem(`${LOCAL_CONTENT_PREFIX}${importId}`, JSON.stringify(payload));
  });
}

export function readLocalImportContents(importId: string): Record<string, string> {
  const raw = sessionStorage.getItem(`${LOCAL_CONTENT_PREFIX}${importId}`);
  if (raw == null) return {};
  try {
    return JSON.parse(raw) as Record<string, string>;
  } catch {
    return {};
  }
}
